module.exports = __webpack_public_path__ + "img/graphene-lv2.27988f7d.png";